import { createSlice } from '@reduxjs/toolkit';

// Initial state
export const initialState = {
    navSteps: [
        { code: 'welcome', title: 'Welcome' },
        { code: 'contacts', title: 'Organization Admins' },
        { code: 'participation', title: 'Club Participation' },
        { code: 'details', title: 'Club Details' },
        { code: 'training', title: 'Training Requirements' },
        {
            code: 'complete',
            linkToStepTitle: 'Done with Training Requirements',
            title: 'Registration Complete',
        },
    ],
    activeStep: 'welcome',
    latestStep: 'welcome',
};

const registrationSlice = createSlice({
    name: 'bgca/registration',
    initialState: () => initialState,
    reducers: {
        setActiveStep: (state, action) => {
            const newActiveStep = action.payload;
            if (state.activeStep === newActiveStep || !state.navSteps.find(item => item.code === newActiveStep)) {
                return;
            }

            state.activeStep = newActiveStep;
        },
        goToNextStep: (state, action) => {
            const index = state.navSteps.findIndex(item => item.code === state.activeStep);
            if (index === state.navSteps.length - 1) {
                return;
            }

            const latestIndex = state.navSteps.findIndex(item => item.code === state.latestStep);
            const nextCode = state.navSteps[index + 1].code;

            state.activeStep = nextCode;
            if (latestIndex <= index + 1) {
                state.latestStep = nextCode;
            }
        },
        goToPrevStep: (state, action) => {
            const index = state.navSteps.findIndex(item => item.code === state.activeStep);
            if (index === 0) {
                return;
            }

            state.activeStep = state.navSteps[index - 1].code;
        },
    },
});

export default registrationSlice.reducer;
export const persistedKeys = ['activeStep', 'latestStep'];
export const { setActiveStep, goToNextStep, goToPrevStep } = registrationSlice.actions;
